import { ServiceType } from "./models/service/servicetype.model";
import { Injectable } from "@angular/core";

@Injectable()
export class AccountTypeService {
  constructor() {

  }
  getListAccountType(agentid): ServiceType[] {
    let typeList: ServiceType[] = [];
    // đại lý chúa không được tạo KD và API
    if (agentid == 1) {
      typeList.push(new ServiceType(2, 'Quản trị'));
      typeList.push(new ServiceType(3, 'Kế toán'));
      typeList.push(new ServiceType(6, 'Chăm sóc khách hàng'));
    }
    else {
      typeList.push(new ServiceType(1, 'Supper Admin'));
      typeList.push(new ServiceType(2, 'Quản trị'));
      typeList.push(new ServiceType(3, 'Kế toán'));
      typeList.push(new ServiceType(4, 'Kinh doanh'));
      typeList.push(new ServiceType(5, 'Api'));
      typeList.push(new ServiceType(6, 'Chăm sóc khách hàng'));
    }

    return typeList;
  }
}
